import React from 'react'
import {graphql, useStaticQuery} from 'gatsby'
import { renderRichText } from "gatsby-source-contentful/rich-text"
import { GatsbyImage } from "gatsby-plugin-image";


import * as aboutStyles from './about.module.scss'

const About = () => {
    const data = useStaticQuery(graphql`
    query {
        contentfulComponentContent (name: {eq: "About Me"}) {
          primaryImage {
            title
            imgixImage {
              gatsbyImageData (layout: CONSTRAINED, width: 800, imgixParams: {q: 75})
            }
          }
          headline
          body {
            raw
          }
        }
      }
    `)
      return (
          <div className={aboutStyles.container}>
              <div className={aboutStyles.imageBox}>
                <GatsbyImage
                    image={data.contentfulComponentContent.primaryImage.imgixImage.gatsbyImageData}
                    className={aboutStyles.image}
                    alt={data.contentfulComponentContent.primaryImage.title} />
              </div>
                <div className={aboutStyles.textBox}>
                    <h2 className={aboutStyles.heading}>
                        {data.contentfulComponentContent.headline}
                    </h2>
                <div className={aboutStyles.text}>
                    {renderRichText(data.contentfulComponentContent.body)}
                </div>
              </div>
          </div>
      );
}

export default About